<template>
  <label class="search-input" :class="class_list">
    <search-icon :size="14"/>
    <input
      class="search-input__item"
      ref="input"
      :type="type"
      :placeholder="placeholder"
      :value="value"
      :disabled="disabled"
      :readonly="read_only"
      :required="required"
      @change="$emit('change', $event)"
      @click="$emit('click', $event)"
      @enter="$emit('enter', $event)"
      @mouseleave="$emit('mouseleave', $event)"
      @key_down="$emit('key_down', $event)"
      @key_up="$emit('key_up', $event)"
    />
  </label>
</template>

<script>

import EyeIcon from "../icons/EyeIcon";
import SearchIcon from "../icons/SearchIcon";

export default {
  name: "SearchInput",
  components: {SearchIcon, EyeIcon},

  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Search...'
    },
    type: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    read_only: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    class_list() {
      return {
        disabled: this.disabled,
        error: this.error,
      }
    }
  },
  mounted() {
    this.$refs.input.addEventListener('input', this.inputEvent)
  },
  beforeDestroy() {
    this.$refs.input.removeEventListener('input', this.inputEvent)
  },
  methods: {
    inputEvent(event) {
      if (this.disabled) return
      return this.$emit('input', event.target.value)
    },
    focus() {
      this.$refs.input.focus()
    }
  }
}
</script>
